import { ReservablesList } from '@/components/rooms-list';
import VisitorLayout from '@/layouts/visitor-layout';
import { roomsShow } from '@/routes';
import { Head } from '@inertiajs/react';

export default function Rooms({
    response,
}: {
    response: {
        rooms: App.Data.RoomData[];
        customer: App.Data.CustomerData | null;
        newsletters: App.Data.NewsletterData[];
    };
}) {
    return (
        <VisitorLayout>
            <Head>
                <title>Our Rooms</title>
                <meta name="description" content="View our rooms and find the perfect one for your event and book it online" />
                <meta name="image" content={import.meta.env.VITE_APP_URL + '/logo.jpg'} />
                <meta name="url" content={roomsShow().url} />
                <meta name="canonical_url" content={roomsShow().url} />
                <meta name="type" content="website" />
                <meta name="author" content="Let\'s Cafe" />
                <meta name="robots" content="index, follow" />
                <meta name="published_time" content={new Date().toISOString()} />
                <meta name="modified_time" content={new Date().toISOString()} />
                <meta name="site_name" content="Let\'s Cafe" />
                <meta name="section" content="Rooms" />
                <meta name="tags" content="rooms, events, bookings" />
                <meta name="twitter_username" content="Let\'s Cafe" />
                <meta name="og:title" content="Our Rooms" />
                <meta name="og:description" content="View our rooms and find the perfect one for your event and book it online" />
                <meta name="og:image" content={import.meta.env.VITE_APP_URL + '/logo.jpg'} />
                <meta name="og:url" content={roomsShow().url} />
                <meta name="og:type" content="website" />
                <meta name="og:site_name" content="Let\'s Cafe" />
                <meta name="og:section" content="Rooms" />
                <meta name="og:tags" content="rooms, events, bookings" />
                <meta name="og:twitter_username" content="Let\'s Cafe" />
                <meta name="og:published_time" content={new Date().toISOString()} />
                <meta name="og:modified_time" content={new Date().toISOString()} />
                <meta name="og:locale" content="en" />
                <meta name="og:canonical_url" content={roomsShow().url} />
                <meta name="og:alternates" content={roomsShow().url} />
                <meta name="og:schema" content={roomsShow().url} />
            </Head>
            <ReservablesList
                reservables={response.rooms}
                customer={response.customer}
                reservableType="room"
            />
        </VisitorLayout>
    );
}
